import React from "react";
import loadable from "@loadable/component";
//import RegistrationFormContentLoader from "../../components/Registration/widgets/RegistrationFormContentLoader";
import SignUpFormContentLoader from "./widgets/SignUpFormContentLoader";

const ContentLoaderFunction: React.FC = () => {
    return <SignUpFormContentLoader />;
};
export default loadable(() => import(/* webpackChunkName: 'registration' */ "../Registration"), {
    fallback: <ContentLoaderFunction />,
});
